/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IVinhusetLocationRedirectData } from './vinhuset-location-redirect.data';
import { IVinhusetLocationRedirectProps } from './vinhuset-location-redirect.props.autogenerated';

/**
 *
 * VinhusetLocationRedirect component
 * @extends {React.PureComponent<IVinhusetLocationRedirectProps<IVinhusetLocationRedirectData>>}
 */
class VinhusetLocationRedirect extends React.PureComponent<IVinhusetLocationRedirectProps<IVinhusetLocationRedirectData>> {
    public componentDidMount(): void {
        const {
            config: { disable, redirects },
            context,
            data: { accountInformation }
        } = this.props;

        if (disable) {
            return;
        }

        const location = accountInformation.result?.ExtensionProperties?.find(x => x.Key === 'LOCATION')?.Value?.StringValue;

        // Check if already in the correct location (or both are null)
        if (!location || location === context.request.channel?.InventLocation) {
            return;
        }

        // Get the redirect for the proper location for this user's warehouse
        const redirect = redirects?.find(x => x.warehouse === location);

        if (!redirect) {
            return;
        }

        // Get current path and site path
        const currentPath = context.request.url.requestUrl.pathname + context.request.url.requestUrl.search;
        const sitePath = context.request.sitePath;

        // Create the new path
        const basePath = redirect.redirectUrl.destinationUrl.split('?')[0];
        const newPath = `${basePath}${currentPath.substring(sitePath?.length || 0)}`;

        // Redirect to the new path
        window.location.replace(newPath);
    }

    public render(): JSX.Element | null {
        return null;
    }
}

export default VinhusetLocationRedirect;
